import EmphasisLight from './emphasis-light';
export default EmphasisLight;
